/*@flow*/

export default [
  {
    node: {
      location: {
        lat: 40.689115,
        lon: -73.98137,
      },
      name: 'DBP-2 - Fulton St & Flatbush Ave',
      serialno: 'NUM200B001S0002',
    },
  },
  {
    node: {
      location: {
        lat: 40.689445,
        lon: -73.982431,
      },
      name: 'DBP-1 - Fulton St & Bond St',
      serialno: 'NUM200B001S0001',
    },
  },
  {
    node: {
      location: {
        lat: 40.689305,
        lon: -73.981828,
      },
      name: 'DBP-4 - Fulton St & Hanover Pl mid-block',
      serialno: 'NUM200B001S0004',
    },
  },
  {
    node: {
      location: {
        lat: 40.689305,
        lon: -73.981828,
      },
      name: 'DBP-3 - Fulton St & Hanover Pl',
      serialno: 'NUM200B001S0003',
    },
  },
];
